var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSecureEuro = function SvgSecureEuro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "currentColor",
    d: "M12 1 3 5v6c0 5.5 3.8 10.7 9 12 5.2-1.3 9-6.5 9-12V5Zm7 11c-.5 4.1-3.3 7.8-7 8.9-3.7-1.1-6.5-4.8-7-8.9V6.3l7-3.1 7 3.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "currentColor",
    d: "M13.11 13.088h-2.127a2.015 2.015 0 0 0 .5 1.4 1.97 1.97 0 0 0 1.452.475 3.5 3.5 0 0 0 1.2-.2l.232 1.537a7.112 7.112 0 0 1-1.625.184 3.749 3.749 0 0 1-2.644-.9 3.383 3.383 0 0 1-1.025-2.5H8v-.961h1.073v-.787H8v-.965h1.085a3.466 3.466 0 0 1 1.114-2.485 3.893 3.893 0 0 1 2.669-.885 6.571 6.571 0 0 1 1.5.2l-.233 1.538a3.629 3.629 0 0 0-1.174-.2 1.783 1.783 0 0 0-1.965 1.832h2.114v.965h-2.127v.787h2.127Z"
  })));
};
export default SvgSecureEuro;